<!--
 * @Author: ZS
 * @Date: 2020-06-18 16:24:41
 * @LastEditors: ZS
 * @LastEditTime: 2020-07-17 11:15:39
 * @Description: file content
-->
<template>
  <div class="myBusiness">
    <!-- 筛选条件 -->
    <!-- 待办/已办 -->
    <div class="search_wrap" :key="flag">
      <template v-for="(item, index) in searchList">
        <div
          class="search_item"
          :key="index"
        >
          <span class="left">{{item.label}}</span>
          <span class="right">
            <template v-if="item.field === 'text'">
              <el-input
                v-model="searchData[item.code]"
                placeholder="请输入内容"
                size="medium"
                clearable
                v-blurTrim
              ></el-input>
            </template>
            <template v-if="item.field === 'date-range'">
              <el-date-picker
                v-model="searchData[item.code[0]]"
                placeholder="请选择"
                value-format="yyyy-MM-dd"
                clearable
                size="medium"
                style="width: 140px;"
              ></el-date-picker>
              <span class="connection">至</span>
              <el-date-picker
                v-model="searchData[item.code[1]]"
                placeholder="请选择"
                value-format="yyyy-MM-dd"
                clearable
                size="medium"
                style="width: 140px;"
              ></el-date-picker>
            </template>
          </span>
        </div>
      </template>
      <div class="search_item btn_item">
        <el-button
          type="primary"
          size="medium"
          @click="searchFunc"
          class="search_btn"
        >搜索</el-button>
        <el-button
          size="medium"
          @click="resetFunc"
        >重置</el-button>
      </div>
    </div>
    <div
      v-loading="loadingFlag"
    >
      <Table
        border
        :tableData="tableData"
        :theadData="theadData"
        :has-check="false"
        :key="flag"
      >
        <template v-slot:guideline="{ scope }">
          <span>{{scope.row.guidelineName}}</span>
          <el-tag
            type="success"
            effect="dark"
            size="mini"
            v-if="scope.row.processstatus == 2"
          >正常</el-tag>
          <el-tag
            type="warning"
            effect="dark"
            size="mini"
            v-if="scope.row.processstatus == 3"
          >预警</el-tag>
          <el-tag
            type="danger"
            effect="dark"
            size="mini"
            v-if="scope.row.processstatus == 1"
          >超期</el-tag>
        </template>
        <template v-slot:ope="{ scope }">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)"
            class="detailBtn"
          >详情</el-button>
        </template>
      </Table>
    </div>
    <div
      class="block fenyeBox"
      v-if="totalSize"
    >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="100"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalSize"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="我要咨询"
      :visible.sync="inquiryVisible"
    >
      <el-input
        type="textarea"
        :rows="2"
        placeholder="请输入内容"
        v-model="textarea"
      >
      </el-input>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="inquiryVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="inquiryVisible = false"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
import Table from "@/components/table/table.vue";
import { findWork, findMessage } from "@/api/workBench.js";
export default {
  components: {
    Table
  },
  props: {
    numChange: {
      type: Function
    },
    flag: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      tableData: {
        data0: [],
        data1: [],
        data2: [],
        data3: []
      },
      // 表格数据
      tableData: [],
      currentPage: 0,
      pageSize: 10,
      totalSize: 0,
      loadingFlag: false,
      // titIndex: 0,
      inquiryVisible: false,
      textarea: "",
      // 查询条件
      searchData: {},
      oldSearchData: {}
    };
  },
  computed: {
    theadData() {
      // if (this.flag === 1) {
      //   return [
      //     { name: "序号", code: "index", width: 60 },
      //     {
      //       name: "事项名称",
      //       code: "guideline",
      //       slotName: "guideline",
      //       align: "left"
      //     },
      //     { name: "发起人", code: "userName", width: 150 },
      //     { name: "发起时间", code: "processinstancecreatetime", width: 180 },
      //     { name: "当前节点", code: "taskName", width: 150 },
      //     { name: "操作", code: "ope", slotName: "ope", width: 100 }
      //   ];
      // } else if (this.flag === 2) {
      //   return [
      //     { name: "序号", code: "index", width: 60 },
      //     { name: "标题", code: "messagetitle", align: "left" },
      //     { name: "发送人", code: "sendName", width: 150 },
      //     { name: "发送时间", code: "sendtime", width: 180 },
      //     { name: "操作", code: "ope", slotName: "ope", width: 100 }
      //   ];
      // } else if (this.flag === 3) {
      //   return [
      //     { name: "序号", code: "index", width: 60 },
      //     {
      //       name: "事项名称",
      //       code: "guideline",
      //       slotName: "guideline",
      //       align: "left"
      //     },
      //     { name: "发起人", code: "userName", width: 150 },
      //     { name: "发起时间", code: "processinstancecreatetime", width: 180 },
      //     { name: "办理时间", code: "progressnodeendtime", width: 180 },
      //     { name: "操作", code: "ope", slotName: "ope", width: 100 }
      //   ];
      // } else if (this.flag === 4) {
      //   return [
      //     { name: "序号", code: "index", width: 60 },
      //     { name: "标题", code: "messagetitle", align: "left" },
      //     { name: "发送人", code: "sendName", width: 150 },
      //     { name: "发送时间", code: "sendtime", width: 180 },
      //     { name: "阅读时间", code: "readtime", width: 180 },
      //     { name: "操作", code: "ope", slotName: "ope", width: 100 }
      //   ]
      // }
      let obj = {
        1: [
          { name: "序号", code: "index", width: 60 },
          {
            name: "事项名称",
            code: "guideline",
            slotName: "guideline",
            align: "left"
          },
          { name: "发起人", code: "userName", width: 150 },
          { name: "发起时间", code: "processinstancecreatetime", width: 180 },
          { name: "当前节点", code: "taskName", width: 150 },
          { name: "操作", code: "ope", slotName: "ope", width: 100 }
        ],
        2: [
          { name: "序号", code: "index", width: 60 },
          { name: "标题", code: "messagetitle", align: "left" },
          { name: "发送人", code: "sendName", width: 150 },
          { name: "发送时间", code: "sendtime", width: 180 },
          { name: "操作", code: "ope", slotName: "ope", width: 100 }
        ],
        3: [
          { name: "序号", code: "index", width: 60 },
          {
            name: "事项名称",
            code: "guideline",
            slotName: "guideline",
            align: "left"
          },
          { name: "发起人", code: "userName", width: 150 },
          { name: "发起时间", code: "processinstancecreatetime", width: 180 },
          { name: "办理时间", code: "progressnodeendtime", width: 180 },
          { name: "操作", code: "ope", slotName: "ope", width: 100 }
        ],
        4: [
          { name: "序号", code: "index", width: 60 },
          { name: "标题", code: "messagetitle", align: "left" },
          { name: "发送人", code: "sendName", width: 150 },
          { name: "发送时间", code: "sendtime", width: 180 },
          { name: "阅读时间", code: "readtime", width: 180 },
          { name: "操作", code: "ope", slotName: "ope", width: 100 }
        ]
      };
      return obj[this.flag];
    },
    searchList() {
      if (this.flag === 1) {
        return [
          { label: "事项名称", code: "guidelineName", field: "text" },
          { label: "发起人", code: "progressNodeMemberName", field: "text" },
          { label: "当前节点", code: "nodeName", field: "text" },
          {
            label: "发起时间",
            field: "date-range",
            code: ["startTime", "endTime"]
          }
        ];
      } else if (this.flag === 3) {
        return [
          { label: "事项名称", code: "guidelineName", field: "text" },
          { label: "发起人", code: "progressNodeMemberName", field: "text" },
          // { label: "当前节点", code: "nodeName", field: "text" },
          {
            label: "发起时间",
            field: "date-range",
            code: ["startTime", "endTime"]
          },
          {
            label: "办理时间",
            field: "date-range",
            code: ["startTimeYb", "endTimeYb"]
          }
        ];
      } else {
        return [
          { label: "标题", code: "messageTitle", field: "text" },
          { label: "发送人", code: "sendUserName", field: "text" },
          {
            label: "发送时间",
            field: "date-range",
            code: ["startTime", "endTime"]
          }
        ];
      }
    },
    initSearchData() {
      if (this.flag === 1) {
        return {
          guidelineName: "",
          progressNodeMemberName: "",
          nodeName: "",
          startTime: "",
          endTime: ""
        };
      } else if (this.flag === 3) {
        return {
          guidelineName: "",
          progressNodeMemberName: "",
          // nodeName: "",
          startTime: "",
          endTime: "",
          startTimeYb: "",
          endTimeYb: ""
        };
      } else {
        // 待阅/已阅
        return {
          messageTitle: "",
          sendUserName: "",
          startTime: "",
          endTime: ""
        };
      }
    }
  },
  watch: {
    flag() {
      this.searchData = {
      ...this.initSearchData
    };
    this.oldSearchData = {
      ...this.initSearchData
    };
      this.searchFunc();
    }
  },
  mounted() {
    this.searchData = {
      ...this.initSearchData
    };
    this.oldSearchData = {
      ...this.initSearchData
    };
    this.searchFunc();
  },
  methods: {
    /**
     * @name searchFunc
     * @description 查询方法
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-09-02 14:08:32
     */
    searchFunc() {
      // 时间格式校验
      // if ([1, 3].indexOf(this.flag) > -1) {
      // 判断发起时间
      const { startTime, endTime } = this.searchData;
      if (startTime && endTime && new Date(startTime) > new Date(endTime)) {
        // 如果两个时间都选择，且起始时间大于结束时间
        this.$message({
          type: "warning",
          message: "起始时间不能早于结束时间"
        });
        return;
      }
      // }
      if (this.flag === 3) {
        const { startTimeYb, endTimeYb } = this.searchData;
        if (
          startTimeYb &&
          endTimeYb &&
          new Date(startTimeYb) > new Date(endTimeYb)
        ) {
          // 如果两个时间都选择，且起始时间大于结束时间
          this.$message({
            type: "warning",
            message: "起始时间不能早于结束时间"
          });
          return;
        }
      }
      this.oldSearchData = {
        ...this.searchData
      };
      this.handleCurrentChange(1);
    },
    /**
     * @name resetFunc
     * @description 重置方法
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-09-02 14:09:02
     */
    resetFunc() {
      this.searchData = {
        ...this.initSearchData
      };
      this.searchFunc();
    },
    /**
     * @name getData
     * @description 获取数据
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-09-02 11:09:30
     */
    getData() {
      this.currentPage = 1;
      this.tableData = [];
      this.getTableData();
    },
    /**
     * @name getTableData
     * @description 获取表格数据
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-09-02 11:30:16
     */
    async getTableData() {
      const obj = {
        findWork,
        findMessage
      };
      let url = "findWork";
      let state = 0,
        typeStr = "resultType";
      if ([2, 4].indexOf(this.flag) > -1) {
        url = "findMessage";
        typeStr = "readStatus";
      }
      if ([3, 4].indexOf(this.flag) > -1) {
        state = 1;
      }
      let res = null;
      // this.loadingFlag = true;
      try {
        res = await obj[url](
          qs.stringify({
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            [typeStr]: state,
            ...this.oldSearchData
          })
          // "pageNum=1&pageSize=10&resultType=0"
        );
      } catch (error) {
        // 请求失败
        this.tableData = [];
        this.totalSize = 0;
        this.loadingFlag = false;
        return;
      }
      // this.loadingFlag = false;
      let list = res.dataList || [];
      list.map((item, index) => {
        item.index = this.pageSize * (this.currentPage - 1) + index + 1;
      });
      this.totalSize = res.count;
      this.tableData = list;
    },
    /**
     * @name handleCurrentChange
     * @description 切换页码
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-09-02 11:36:15
     */
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },
    /**
     * @name handleSizeChange
     * @description 切换每页条数
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-09-02 11:37:05
     */
    handleSizeChange(val) {
      this.pageSize = val;
      this.handleCurrentChange(this.currentPage);
    },
    handleEdit(index, row) {
      window.open(row.taskUrl);
    },
    inquiryOpen(index, row) {
      this.inquiryVisible = true;
    }
  }
};
</script>

<style scoped>
.myTit {
  /* line-height: 42px; */
  padding: 30px 0 15px 0;
  font-size: 16px;
  margin-bottom: 10px;
}

.myTit > span {
  float: left;
  color: #091b28;
  font-size: 22px;
  font-family: PingFang SC;
}

.myTit > ul {
  float: right;
}

.myTit > ul > li {
  float: left;
  width: 84px;
  height: 34px;
  background: rgba(53, 139, 247, 0.1);
  color: #687986;
  line-height: 34px;
  font-size: 16px;
  font-weight: normal;
  text-align: center;
  cursor: pointer;
}

.myTit > ul > li.active {
  background-color: #358bf7;
  color: #fff;
}

.detailBtn,
.advisoryBtn {
  width: 56px;
  height: 27px;
  border-radius: 14px;
  padding: 0;
  text-align: center;
  font-size: 13px;
  color: #fff;
  border: none;
}

.detailBtn {
  background: rgba(255, 165, 71, 1);
}

.detailBtn:hover,
.detailBtn:focus {
  background: rgba(255, 165, 71, 0.8);
  color: #fff;
}

.advisoryBtn {
  background: rgba(53, 139, 247, 1);
}

.advisoryBtn:hover,
.advisoryBtn:focus {
  background: rgba(53, 139, 247, 0.8);
  color: #fff;
}

.fenyeBox {
  text-align: center;
  padding-top: 20px;
}

.newBg {
  display: inline-block;
  width: 55px;
  height: 23px;
  line-height: 22px;
  background: url(../../../static/images/newBg.png) no-repeat 0px 0px;
  text-align: center;
  color: #fff;
  margin-left: 6px;
}
</style>
<style lang="scss" scoped>
@import "./common.scss";
</style>



// WEBPACK FOOTER //
// src/components/workbench/ApprovalWork.vue